module.exports = __webpack_public_path__ + "static/sellesmp-logo-443b6feee0f6334aceb0dae26bd161e8.png";